import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class WorkflowStatusDataService {

  constructor(private http: HttpClient) { }

  getJobReq(jobReqId: number): Observable<any> {
    const url = `/recruiting/job-reqs/${jobReqId}`;

    return this.http.get(url);
  }

  getDueDate(jobReqId: number, candidateId: number): Observable<any> {
    let url = `/hr/employment-apps/new-payload?jobRequisitionId=${jobReqId}&candidateId=${candidateId}`;

    return this.http.get<any>(url);
  }
}
